// src/data/dramas.ts
import { Drama } from "../types";
import saavadi1 from "../images/saavadi1.jpg";
import saavadi2 from "../images/saavadi2.jpg";
import * as naai from "../images/naai";
import * as s25 from "../images/sangae25";
import * as playersImages from "../images/players";
import * as saavadi from "../images/saavadi";

export const dramas: Drama[] = [
  {
    title: "Sangae Muzhangu 2025",
    description:
      "23rd edition of the biggest Tamil student prouction in Singapore. A groundbreaking, futuristic, and technologically driven play.",
    role: "Sam Roy",
    productionCompany: "NUS TLS",
    year: "2025",
    language: "Tamil",
    image: { url: s25.s25_4, thumbnail: s25.s25_4_thumb },
    bannerImage: { url: s25.s25_4 },
    venue: "University Cultural Centre",
    director: "Vinith Kumar",
    galleryImages: [
      s25.s25_2,
      s25.s25_3,
      s25.s25_4,
      s25.s25_5,
      s25.s25_11,
      s25.s25_13,
      s25.s25_6,
      s25.s25_7,
      s25.s25_8,
      s25.s25_9,
      s25.s25_10,
      s25.s25_1,
    ],
    galleryThumbnails: [
      s25.s25_2_thumb,
      s25.s25_3_thumb,
      s25.s25_4_thumb,
      s25.s25_5_thumb,
      s25.s25_11_thumb,
      s25.s25_13_thumb,
      s25.s25_6_thumb,
      s25.s25_7_thumb,
      s25.s25_8_thumb,
      s25.s25_9_thumb,
      s25.s25_10_thumb,
      s25.s25_1_thumb,
    ],
    videoLink: "https://www.youtube.com/watch?v=yG9cDvA4OsA&t=1402s",
  },
  {
    title: "Saavadi",
    description: `Chithirapathi Nagesh, once a celebrated playwright, is desperate to revive his fading career.
    When his former student Arul Rajan arrives with a brilliant new script, hope returns — briefly.
    What begins as the promise of a creative partnership soon twists into something far more dangerous.`,
    role: "Arul Rajan",
    productionCompany: "Agam Theatre Lab",
    year: "2025",
    language: "Tamil",
    image: { url: saavadi.saavadi1, thumbnail: saavadi.saavadi1_thumb },
    bannerImage: { url: saavadi.saavadi1 },
    venue: "The Theatre Lab",
    director: "Akhilesh",
    galleryImages: [
      //saavadi.saavadi1,
      saavadi.saavadi2,
      saavadi.saavadi3,
      saavadi.saavadi4,
      saavadi.saavadi5,
      saavadi.saavadi6,
      saavadi.saavadi7,
      saavadi.saavadi8,
      saavadi.saavadi9,
      saavadi.saavadi10,
      saavadi.saavadi11,
      saavadi.saavadi12,
      saavadi.saavadi13,
      saavadi.saavadi14,
      saavadi.saavadi15,
      saavadi.saavadi16,
      saavadi.saavadi17,
      saavadi.saavadi18,
      saavadi.saavadi19,
      saavadi.saavadi20,
      saavadi.saavadi21,
    ],
    galleryThumbnails: [
      //saavadi.saavadi1_thumb,
      saavadi.saavadi2_thumb,
      saavadi.saavadi3_thumb,
      saavadi.saavadi4_thumb,
      saavadi.saavadi5_thumb,
      saavadi.saavadi6_thumb,
      saavadi.saavadi7_thumb,
      saavadi.saavadi8_thumb,
      saavadi.saavadi9_thumb,
      saavadi.saavadi10_thumb,
      saavadi.saavadi11_thumb,
      saavadi.saavadi12_thumb,
      saavadi.saavadi13_thumb,
      saavadi.saavadi14_thumb,
      saavadi.saavadi15_thumb,
      saavadi.saavadi16_thumb,
      saavadi.saavadi17_thumb,
      saavadi.saavadi18_thumb,
      saavadi.saavadi19_thumb,
      saavadi.saavadi20_thumb,
      saavadi.saavadi21_thumb,
    ],
    videoLink: "https://vimeo.com/ondemand/saavadi2",
  },
  {
    title: "Naai",
    description:
      "Naai is written by Nallu Dhinakharan and Karthikeyan and Directed by Karthikeyan, starring Mikhil. In 'Naai - Dog', you are taken on a rollercoaster journey through the twisted mind of an ordinary office worker with dreams of success.",
    role: "Naayakan",
    productionCompany: "Agam Theatre Lab",
    year: "2024",
    language: "Tamil",
    image: { url: naai.naai1, thumbnail: naai.naai1_thumb },
    bannerImage: { url: naai.naai1 },
    venue: "Aliwal Arts Centre",
    director: "Karthikeyan",
    galleryImages: [
      naai.naai1,
      naai.naai2,
      naai.naai3,
      naai.naai4,
      naai.naai5,
      naai.naai6,
      naai.naai7,
      naai.naai8,
    ],
    galleryThumbnails: [
      naai.naai1_thumb,
      naai.naai2_thumb,
      naai.naai3_thumb,
      naai.naai4_thumb,
      naai.naai5_thumb,
      naai.naai6_thumb,
      naai.naai7_thumb,
      naai.naai8_thumb,
    ],
    videoLink:
      "https://www.tabla.com.sg/news/singapore/tamil-theatre-rise-among-youth",
  },
  // {
  //   title: "Sangae Muzhangu 2023",
  //   description:
  //     "A story of a King exploring themes of leadership, the afterlife, and morals. Join him on this emotional journey filled with action, romance and comedy and be prepared to be entertained! Hope you enjoy the show!",
  //   role: "King's Uncle",
  //   productionCompany: "NUS Tamil Language Society",
  //   year: "2023",
  //   language: "Tamil",
  //   image: { url: "https://picsum.photos/seed/macbeth/300/400" },
  //   venue: "University Cultural Centre",
  //   director: "Karthik",
  //   galleryImages: [
  //     "/images/dramas/macbeth/poster.jpg",
  //     "/images/dramas/macbeth/scene1.jpg",
  //     "/images/dramas/macbeth/scene2.jpg",
  //     "/images/dramas/macbeth/cast.jpg",
  //     "/images/dramas/macbeth/backstage.jpg",
  //   ],
  // },
  {
    title: "Raffles Players",
    description: "Plays I was a part of during my time at Raffles Institution!",
    role: "Various",
    productionCompany: "Raffles Players",
    year: "2014-2017",
    language: "English",
    image: {
      url: playersImages.players10,
      thumbnail: playersImages.players10_thumb,
    },
    bannerImage: { url: playersImages.players1 },
    venue: "Raffles Institution",
    director: "Various",
    galleryImages: [
      playersImages.players1,
      playersImages.players2,
      playersImages.players2_1,
      playersImages.players2_2,
      playersImages.players4,
      playersImages.players5,
      playersImages.players6,
      playersImages.players7,
      playersImages.players3,
      playersImages.players8,
      playersImages.players9,
      playersImages.players9_2,
      playersImages.players10,
      playersImages.players11,
    ],
    galleryThumbnails: [
      playersImages.players1_thumb,
      playersImages.players2_thumb,
      playersImages.players2_1_thumb,
      playersImages.players2_2_thumb,
      playersImages.players4_thumb,
      playersImages.players5_thumb,
      playersImages.players6_thumb,
      playersImages.players7_thumb,
      playersImages.players3_thumb,
      playersImages.players8_thumb,
      playersImages.players9_thumb,
      playersImages.players9_2_thumb,
      playersImages.players10_thumb,
      playersImages.players11_thumb,
    ],
    galleryCaptions: [
      "Othello - 2016",
      "Othello - 2016",
      "Othello - 2016",
      "Othello - 2016",
      "SYF - 2017",
      "SYF - 2017",
      "SYF - 2017",
      "Dramafeste - 2014",
      "Dramafeste - 2015",
      "Dramafeste - 2016",
      "Dramafeste - 2016",
      "Dramafeste - 2016",
      "Dramafeste - 2016",
      "Dramafeste awards",
    ],
  },
];
